import React from 'react';
import noop from 'lodash/noop';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import Icon from 'components/base/Icon';
import { getColor } from 'common/constants/_colors';

const Wrapper = styled(Flex)`
  align-items: center;
  border: 1px solid ${getColor('botticelli')};
  border-radius: 0.3rem;
  padding: 0 0.8rem;
`;

const StyledInput = styled.input`
  width: 100%;
  font-size: 1.2rem;
  border: none;
  outline: none;
  background-color: inherit;

  :focus {
    border: none;
    outline: none;
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
    height: 1em;
    width: 1em;
    border-radius: 50em;
    background: url('https://pro.fontawesome.com/releases/v5.10.0/svgs/solid/times-circle.svg')
      no-repeat 50% 50%;
    background-size: contain;
    opacity: 0;
    pointer-events: none;
    cursor: pointer;
  }

  :focus::-webkit-search-cancel-button {
    opacity: 0.3;
    pointer-events: all;
  }
`;

StyledInput.displayName = 'StyledInput';

const SearchInput = ({
  placeholder,
  height = '100%',
  width = '100%',
  onChange = noop,
  value,
  defaultValue = undefined,
  dataTestid = 'search',
  dataCy = 'search',
  disabled = false
}) => (
  <Wrapper height={height} width={width}>
    <Icon name='Search' color='frenchGray' />
    <StyledInput
      type='search'
      data-testid={dataTestid}
      value={value}
      defaultValue={defaultValue}
      color={getColor('shark')}
      placeholder={placeholder}
      onChange={event => onChange(event.target.value)}
      onKeyDown={event => event.stopPropagation()}
      data-cy={dataCy}
      disabled={disabled}
    />
  </Wrapper>
);

export default SearchInput;
